import React, { Component } from "react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ScrollToView from "./../Components/Scroll/ScrollToView";
// import Header from './../Components/Header/Header';
import Footer from "./../Components/Footer/Footer";
import Loadable from "react-loadable";
import LoadingComponent from "./../Pages/Loading/Loading";

const Unsubscribe = Loadable({
   loader: () => import("../Pages/Unsubscribe/Unsubscribe"),
   loading: LoadingComponent,
});

const LayoutHeader = ({ children }) => (
   <div>
      {children}
      <Footer />
   </div>
);

export class LayoutNoHeader extends Component {
   render() {
      return (
         <div className='wrapper'>
            <Router basename={process.env.PUBLIC_URL}>
               <ScrollToView>
                  <Switch>
                     <LayoutHeader>
                        <Route
                           path='/unsubscribe'
                           name='Unsubscribe'
                           component={Unsubscribe}
                           exact
                        />
                     </LayoutHeader>
                  </Switch>
               </ScrollToView>
            </Router>
         </div>
      );
   }
}

export default LayoutNoHeader;
